import moment from "moment";

export const getFeedbackSearchResultsRespMaritime = (params, body) => {
  const commentTexts = {
    EFFICIENT_AUXILIARY_ENGINE_USE: [
      "Unpredicted increase in energy demand",
      "Auxiliary engine malfunctioned",
      "Crew shortage delayed engine operation optimization",
      "An unforeseen power surge demanded an immediate increase in engine load to stabilize performance, diverting attention and resources from planned tasks",
    ],
    OPTIMAL_SAILING: [
      "RPM control system malfunctioned, causing unexpected deviations from the intended track. Crew had to manually adjust course frequently, impacting fuel efficiency and voyage time.",
      "Strong currents forced deviation from track",
      "Unforeseen weather conditions impacted efficiency",
    ],
    OPTIMAL_TRIM: [
      "Lack of access to trim table data",
      "Allocation of time to address pressing mechanical issues took precedence, leaving insufficient time for trim adjustment.",
      "Equipment failure prevented trim adjustment",
    ],
    EFFICIENT_SFOC: [
      "Planned maintenance schedule disrupted by emergency repair",
      "Limited access to necessary spare parts",
      "Overlapping tasks caused delay in maintenance",
      "Critical spare parts unavailable for immediate replacement",
      "Safety concerns delayed maintenance operations",
    ],
  };

  //Set all comments to the same date
  const eventOccurrenceMonth =
    params?.startDate != null
      ? params.startDate
      : moment.utc().startOf("month").valueOf();

  //Loop over all the Comment Texts above and turn them into comments
  let comments = [];
  Object.keys(commentTexts).forEach((behaviourKey) => {
    if (body?.behaviourNames?.length) {
      //Skip this behaviour if Behaviour Type filter is set
      if (!body.behaviourNames.includes(behaviourKey)) {
        return;
      }
    }
    const acronym = behaviourKey
      .split("_")
      .map((s) => s.charAt(0))
      .join("");
    commentTexts[behaviourKey].forEach((comment) => {
      comments.push({
        comment,
        eventOccurrenceMonth: eventOccurrenceMonth,
        behaviourAcronym: acronym,
        behaviourName: behaviourKey,
      });
    });
  });

  //Remove comments based on how many filters are set (removalFactor 3 -> array is divided by 3)
  let removalFactor = 1;
  if (body?.success === true) removalFactor += 5;
  if (body?.success === false) removalFactor += 1;
  if (body?.origin != null) removalFactor += 1;
  if (body?.destination != null) removalFactor += 1;
  if (removalFactor > 1) {
    comments.sort(() => Math.random() - 0.5);
    comments = comments.splice(0, Math.ceil(comments.length / removalFactor));
  }

  return {
    commentCount: comments.length,
    comments,
  };
};
